import styled from "styled-components";
import dompurify from "dompurify";
import {useEffect, useState} from "react";
import {fetchQuillData} from "../serverAPI";

const ContactContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 80px;
  margin-left: 30px;
  margin-bottom: 400px;
`;

const Title = styled.p`
  font-size: 26px;
  font-family: signika, sans-serif;
  color: rgb(0, 148, 255);
`;

const MainText = styled.p`
  font-size: 15px;
  line-height: 1.4em;
  font-weight: lighter;
  align-self: center;
`;

const Border = styled.div`
  height: 95px;
  width: 5px;
  border-left: 2px solid rgb(0, 148, 255);
  border-right: 1px solid rgb(0, 148, 255);
  margin: 0 20px;
`;

const SanitizerInner = styled.p`
  font-size: 15px;
  line-height: 1.4em;
  font-weight: lighter;
  align-self: center;
`;

export default function Contact() {
  const sanitizer = dompurify.sanitize;
  const [contact, setContact] = useState("");

  useEffect(() => {
    const loadContactQuillData = async () => {
      const quillData = await fetchQuillData("contact");
      setContact(quillData);
    };
    loadContactQuillData();
  }, []);

  return (<div>
    <ContactContainer>
      <Title>Contact</Title>
      <Border/>
      <SanitizerInner dangerouslySetInnerHTML={{__html: sanitizer(contact)}}/>
      {/*<MainText>Chung-Moon-Soul Building (E16 Building) 305-Ho<br/>*/}
      {/*  Department of Bio and Brain Engineering, KAIST<br/>*/}
      {/*  291, Daehak-ro, Yuseong-gu, Daejeon 34141, Republic of Korea<br/>*/}
      {/*  Tel: +82-42-350-4352, Fax : +82-42-350-4310</MainText>*/}
    </ContactContainer>
  </div>);
}
